import React from 'react';
import { Link } from 'react-router-dom';

const Footer = ({ post }) => {

    if (!post || post?.show_footer === false) return null;

    return (
        <footer className="c-footer c-page__block">
            <div className="l-grid">
                <div className="l-grid__col">
                    {post.ftr_pos && (
                        <div 
                            className="c-footer__pos-statement scope-text" 
                            dangerouslySetInnerHTML={{ __html: post.ftr_pos }} 
                        />
                    )}
                    
                    {post.ftr_address && (
                        <div 
                            className="c-footer__address scope-text" 
                            dangerouslySetInnerHTML={{ __html: `<p>${post.ftr_address}</p>` }} 
                        />
                    )}
                    
                    <div className="c-footer__contact scope-text scope-text--no-spaces">
                        {post.ftr_phone && post.ftr_phone_url && (
                            <p 
                                dangerouslySetInnerHTML={{ 
                                    __html: `<a href="${post.ftr_phone_url}">${post.ftr_phone}</a>` 
                                }} 
                            />
                        )}
                        
                        {post.ftr_email && (
                            <p 
                                dangerouslySetInnerHTML={{ 
                                    __html: `<a href="mailto:${post.ftr_email}">${post.ftr_email}</a>` 
                                }} 
                            />
                        )}
                    </div>
                    
                    <ul className="c-footer__social">
                        {post.ftr_instagram && (
                            <li className="c-footer__social__item">
                                <a 
									className="c-footer__social__link"
                                    href={post.ftr_instagram} 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                >
                                    Instagram
                                </a>
                            </li>
                        )}
                        
                        {post.ftr_facebook && (
                            <li className="c-footer__social__item">
                                <a 
                                    className="c-footer__social__link"
                                    href={post.ftr_facebook} 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                >
                                    Facebook
                                </a>
                            </li>
                        )}
                        
                        {post.ftr_pinterest && (
                            <li className="c-footer__social__item">
                                <a 
                                    className="c-footer__social__link"
                                    href={post.ftr_pinterest} 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                >
                                    Pinterest
                                </a>
                            </li>
                        )}
						<li className="c-footer__social__item" />
                    </ul>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
